/** @file endQuadEdit: the release of a quad drag: one facet.setEntry, or the fit prompt and a refit batch. */
import { applyEntryResize } from '../art/fit/applyEntryResize';
import { entryResizeFields } from '../art/fit/entryResizeFields';
import type { ViewportCtx } from './viewportCtx';

/** Holds the drawn override until the preview has rebuilt past the batch (no snap back), or drops it on failure. */
function settle(ctx: ViewportCtx, ok: boolean): void {
  if (ok) ctx.quad.holdUntil = ctx.store.getState().puppet.revision;
  else ctx.quad.edit = null;
}

/**
 * Pointer up on a quad drag. Nothing changed: the drag ends. Otherwise the drag stays drawn (`pending`) while its
 * batch is out (`applyEntryResize`: `facet.setEntry` with only the changed fields, "Resize <drawable>" / "Move pivot
 * of <drawable>", or, when the size changed on an entry that holds images, the fit prompt and the refit batch; Cancel
 * drops the drag).
 */
export function endQuadEdit(ctx: ViewportCtx): Promise<void> {
  const e = ctx.quad.edit;
  if (e === null || e.pending) return Promise.resolve();
  const fields = e.moved ? entryResizeFields(e) : null;
  if (fields === null) { ctx.quad.edit = null; return Promise.resolve(); }
  e.pending = true;
  return applyEntryResize(ctx, { ...e, entry: e.ref.entry }, fields).then((ok) => { settle(ctx, ok); });
}
